/**
 * Select Session Prompt Component
 *
 * Displays a message when no session is selected.
 */

import { useTranslation } from 'react-i18next';

export function SelectSessionPrompt() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center text-brand-dark">
        <svg className="w-16 h-16 mx-auto mb-4 text-brand-beige" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
        <p>{t('courses.selectSession')}</p>
      </div>
    </div>
  );
}
